import { Component, OnInit, OnDestroy } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { LoaderSubitoService } from './service/loader-subito.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader-subito',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './loader-subito.component.html',
  styleUrl: './loader-subito.component.css'
})
export class LoaderSubitoComponent implements OnInit, OnDestroy {
  public isLoading = false;
  private subscription: Subscription = new Subscription();

  constructor(public loaderService: LoaderSubitoService) {}

  ngOnInit(): void {
    this.subscription = this.loaderService.isLoading$.subscribe(
      (isLoading) => {
        this.isLoading = isLoading;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
